import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail, Phone } from "lucide-react";
import Wordmark from "@/components/Wordmark";

const NAV = [
  { to: "/how-it-works", label: "How It Works", tid: "footer-how" },
  { to: "/services", label: "Services", tid: "footer-services" },
  { to: "/selected-work", label: "Selected Work", tid: "footer-selected-work" },
  { to: "/journal", label: "Insights", tid: "footer-insights" },
  { to: "/create-with-us", label: "Create With Us", tid: "footer-create" },
  { to: "/connect", label: "Contact Your Producer", tid: "footer-connect" },
];

const CITIES = [
  "Bengaluru",
  "Mumbai",
  "Delhi",
  "Chennai",
  "Hyderabad",
  "Gujarat",
  "Kerala",
  "Rajasthan",
];

// Denim footer. A premium fabric panel with a stitched border,
// like the label on a pair of selvedge jeans.
export default function Footer() {
  return (
    <footer className="denim-panel" data-testid="site-footer">
      <div className="relative max-w-[1280px] mx-auto px-6 md:px-10 py-14 md:py-20">
        <div className="grid grid-cols-2 md:grid-cols-12 gap-x-8 gap-y-10 md:gap-10 items-start">
          {/* Brand */}
          <div className="col-span-2 md:col-span-4">
            <Wordmark size="md" />
            <p className="font-serif-italic font-light text-white/70 text-[17px] md:text-[19px] leading-[1.55] mt-6">
              Made in India.
              <br />
              Producing worldwide.
            </p>
          </div>

          {/* Navigation */}
          <nav className="md:col-span-3 flex flex-col gap-2.5" aria-label="Footer navigation">
            <div className="eyebrow text-white/40 mb-1.5">Navigation</div>
            {NAV.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                className="link-thread w-fit text-[14px] text-white/65 hover:text-white transition-colors"
                data-testid={l.tid}
              >
                {l.label}
              </Link>
            ))}
          </nav>

          {/* Across India */}
          <div className="md:col-span-2">
            <div className="eyebrow text-white/40 mb-1.5">Across India</div>
            <ul className="flex flex-col gap-1.5 text-[13.5px] text-white/65 leading-[1.6] list-none">
              {CITIES.map((c) => (
                <li key={c}>{c}</li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="col-span-2 md:col-span-3">
            <div className="eyebrow text-white/40 mb-1.5">Contact</div>
            <div className="flex flex-col gap-2.5 text-[14px]">
              <a
                href="mailto:ida@brandnewmoneyfilms.com"
                className="link-thread w-fit inline-flex items-center gap-2.5 text-white/65 hover:text-white transition-colors"
                data-testid="footer-email"
              >
                <Mail className="w-4 h-4 shrink-0" aria-hidden />
                <span className="break-all">ida@brandnewmoneyfilms.com</span>
              </a>
              <a
                href="https://instagram.com/brandnewmoneyfilms"
                target="_blank"
                rel="noreferrer"
                className="link-thread w-fit inline-flex items-center gap-2.5 text-white/65 hover:text-white transition-colors"
                data-testid="footer-instagram"
              >
                <Instagram className="w-4 h-4 shrink-0" aria-hidden />
                <span>@brandnewmoneyfilms</span>
              </a>
              <a
                href="tel:+919258651242"
                className="link-thread w-fit inline-flex items-center gap-2.5 text-white/65 hover:text-white transition-colors"
                data-testid="footer-phone"
              >
                <Phone className="w-4 h-4 shrink-0" aria-hidden />
                <span>+91 92586 51242</span>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 md:mt-14 pt-5 border-t border-dashed border-white/25 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 text-[12px] text-white/50 tracking-[0.01em]">
          <span>© {new Date().getFullYear()} Brand New Money Films. All rights reserved.</span>
          <span className="font-serif-italic text-white/45 text-[13px]">Every frame matters.</span>
        </div>
      </div>
    </footer>
  );
}
